
import { get, getAll } from "@/utilities/querySelector";
import { textToHTML } from "@/utilities/textToHtml";

/**
 * Replace <img> tags with SVG content dynamically using jQuery.
 *
 *
 * This function targets all <img> tags with the class 'svg' and replaces them.
 * It preserves the ID, class, and size attributes of the original <img> tag.
 */
const imgSvgs = /** @type {NodeListOf<HTMLImageElement>} */( getAll( 'img.svg' ) );
imgSvgs.forEach( function( img ) {
    const id = img.id;
    const classList = img.classList.toString();
    const url = img.src;
    const ext = url.split( '.' ).pop();
    if ( ext !== 'svg' ) return;

    fetch( url ).then( async ( res ) => {
        const svgString = await res.text();
        const svg = textToHTML( svgString );
        if ( !svg ) return;

        if ( id ) svg.id = id;
        if ( classList ) svg.setAttribute( 'class', classList );
        svg.classList.add( 'replace-svg' );
        const height = svg.getAttribute( 'height' );
        const width = svg.getAttribute( 'width' );
        if ( !svg.getAttribute( 'viewBox' ) && height && width ) {
            svg.setAttribute( 'viewBox', `0 0 ${height} ${width}` );
        }

        img.replaceWith( svg );
    } ).catch( e => {
        console.warn( e );
    } );
} );

const videoPlayButtons = getAll('[data-play-video]');
if (videoPlayButtons) {

    videoPlayButtons.forEach(function(button) {
        const videoId = button.dataset.playVideoId;
        const video = get(`[data-video-id="${videoId}"]`);

        if(video.tagName === 'VIDEO') {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                button.setAttribute('data-play-video', 'true');
                video.play();
            });
        }
    });

    // var tag = document.createElement('script');
    // tag.src = "https://www.youtube.com/iframe_api";
    // var firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // var players = {};

    // function onYouTubeIframeAPIReady() {
    //     videoPlayButtons.forEach(function(button) {
    //         const videoId = button.dataset.playVideoId;
    //         const video = get(`[data-video-id="${videoId}"]`);

    //         // Uses the Youtube Player API to autoplay iframe videos with sound
    //         if (video.tagName.toLowerCase() === 'iframe') {
    //             players[videoId] = new YT.Player(video, {
    //                 events: {
    //                     'onReady': function(event) {
    //                         button.addEventListener('click', function(e) {
    //                             e.preventDefault();
    //                             const videoThumbnail = button.closest('[data-video-thumbnail]');
    //                             videoThumbnail.classList.add('opacity-0', 'pointer-events-none');
    //                             event.target.playVideo();
    //                         });
    //                     }
    //                 }
    //             });
    //         } else {
    //             button.addEventListener('click', function(e) {
    //                 e.preventDefault();
    //                 const videoThumbnail = button.closest('[data-video-thumbnail]');
    //                 videoThumbnail.classList.add('opacity-0', 'pointer-events-none');
    //                 video.play();
    //                 video.setAttribute('controls', true);
    //             });
    //         }
    //     });
    // }

    // window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
}

/**
 * When an element with the back-to-top class is clicked, animate
 * the user to scroll them back to the top of the page.
 */
get( '.back-to-top' )?.addEventListener( 'click', () => {
    document.documentElement.scrollTo( { top: 0, behavior: 'smooth' } );
} );


/**
 * Event listener on button to load newsletter form
 */
const newsletterButton = get('[data-newsletter-content] .button');
if (newsletterButton) {
    newsletterButton?.addEventListener('click', (e) => {
        e.preventDefault();

        console.log('newsletter button clicked');

        const newsletterForm = get('[data-newsletter-form]');
        const newsletterContent = get('[data-newsletter-content]');

        if (newsletterForm) {
            newsletterForm.setAttribute('data-newsletter-form', 'true');
        }

        if (newsletterContent) {
            newsletterContent.setAttribute('data-newsletter-content', 'false');
        }
    });
}

/**
 *
 * @param {string} elementSelector
 * @param {string} targetSelector
 * @param {string} action
 */
function hideElementAtScroll(elementSelector, targetSelector, action = 'hide') {
    window.addEventListener('scroll', () => {
        const button = get(elementSelector);
        const element = get(targetSelector);

        if (!button || !element) return;

        const rect = element.getBoundingClientRect();
        const isInViewport = rect.top <= (window.innerHeight || document.documentElement.clientHeight);

        if (action === 'hide') {
            button.classList.toggle('is-hidden', isInViewport);
            button.classList.toggle('is-visible', !isInViewport);
        } else if (action === 'show') {
            button.classList.toggle('is-hidden', !isInViewport);
            button.classList.toggle('is-visible', isInViewport);
        }
    }, { passive: true });
}

hideElementAtScroll('[data-fixed-call-to-action]', '#book-an-appointment');
hideElementAtScroll('[data-back-to-top]', '[data-footer-main]', 'show');
